var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{staticClass:"cursor-pointer",attrs:{"icon":_vm.iconName,"svgClasses":"live-map-controls-close"},on:{"click":function($event){$event.stopPropagation();return _vm.clickFunction.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }